export type MessageDescriptor = {
  id: string;
  defaultMessage?: string;
};

export function getLocalizedString(defaultStrings: Record<string, string>, localizedStrings: Record<string, string>, selectedKey: string, values: object = {}) {
  return Object.keys(localizedStrings).length
    ? replaceTemplateStringsWithValues(localizedStrings?.[selectedKey], values)
    : replaceTemplateStringsWithValues(defaultStrings[selectedKey], values);
}

export function replaceTemplateStringsWithValues(message: string, values: object) {
  const keys = Object.keys(values);
  let newMessage = message;
  for (const key of keys) {
    const regex = new RegExp(`\\{${key}\\}`, 'g');
    newMessage = newMessage.replace(regex, values[key]);
  }
  return newMessage;
}

function formatMessage(descriptor: MessageDescriptor, values: object = {}) {
  if (descriptor) {
    return replaceTemplateStringsWithValues(descriptor.defaultMessage, values);
  }
  return '';
}

// TODO: delete this export once we update all components to use getIntl()
export const intl = window.aui?.intl || { formatMessage };

export function getIntl() {
  return window.aui?.intl || { formatMessage };
}
